// @flow
import React from 'react';
import exploreIcon from 'assets/images/explore.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  onClick: () => void,
  text: string,
};

export const ExploreButton = (props: Props) => {
  const { onClick, text } = props;
  return (
    <div className={'explore-all-button'} onClick={onClick}>
      <span>{text}</span>
      <img src={exploreIcon} alt={'Explore'} />
    </div>
  );
};
